// Deutsche Webtexte für Zusammen wohnen (golf 8). Gleiche Form wie samenApp.nl.ts. Ruhig und
// erwachsen: nie "Schulden", "Ämtchen", "Punkte" oder Sterne.
export const appSamenDe = {
    words: {
        dinnerTitle: 'Wer isst mit?',
        dinnerTitleCohousing: 'Gemeinsame Mahlzeit',
        costsTitle: 'Kosten teilen',
        costsTitleCohousing: 'Gemeinsame Kosten',
        costsTitleCouple: 'Gemeinsam bezahlen',
        costsTitleTwoHome: 'Kosten für die Kinder',
        emptyStudent: 'Noch niemand. Gibt es Toast?',
        emptyShared: 'Noch niemand angemeldet.',
        emptyCohousing: 'Noch keine Anmeldungen.',
        formerShared: 'Ehemalige Mitbewohnerin oder ehemaliger Mitbewohner',
        formerCohousing: 'Ehemalige Bewohnerin oder ehemaliger Bewohner',
        formerFamily: 'Ehemaliges Familienmitglied',
    },
    nav: {
        dinner: 'Wer isst mit',
        dinnerCohousing: 'Gemeinsames Essen',
        bookings: 'Reservieren',
        costs: 'Kosten',
    },
    common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        close: 'Schließen',
        saved: 'Gespeichert',
        you: 'du',
        left: '(ausgezogen)',
        undo: 'Hoppla',
        moreActions: 'Mehr',
    },
    dinner: {
        intro: 'Wer heute Abend mitisst, wer kocht und bis wann man sich anmeldet.',
        emptyTitle: 'Zusammen essen?',
        emptyBody: 'Wähle eine Frist und wer kocht.',
        start: 'Essensliste starten',
        started: 'Die Essensliste ist bereit.',
        tonight: 'Heute Abend',
        headCook: 'Koch/Köchin {name}',
        headNoCook: 'noch niemand kocht',
        eaters: 'Es essen: {n}',
        guestsExtra: '(+{n} Gast)',
        until: 'Anmelden bis {time} (noch {left})',
        closed: 'Anmeldung geschlossen. Frag {name}.',
        closedNoCook: 'Anmeldung geschlossen.',
        openForYou: 'Die Frist ist vorbei, aber du kannst die Liste noch ändern.',
        noDinner: 'Heute kein gemeinsames Abendessen',
        notDinnerDay: 'An diesem Tag gibt es kein gemeinsames Abendessen.',
        myChoice: 'Meine Wahl',
        imIn: 'Ich esse mit',
        imOut: 'Nicht',
        noChoice: '—',
        guests: 'Gäste',
        guestsHint: 'Nur die Anzahl; keine Namen.',
        groupIn: 'Isst mit',
        groupOut: 'Isst nicht mit',
        groupUnknown: 'Noch nicht gewählt',
        sourceDefault: 'Standard',
        sourceHouse: 'Standard des Hauses',
        sourceAway: 'weg',
        sourceBoard: 'über die Tafel',
        sourceBy: 'eingetragen von {name}',
        sourceCook: 'kocht',
        setFor: 'Für {name}',
        cookTitle: 'Kochen',
        cookClaim: 'Ich koche',
        cookOther: 'Jemand anderes kocht',
        cookRotation: 'Zurück zum Plan',
        cookPick: 'Wer kocht?',
        cookFromRotation: 'laut Plan',
        noDinnerSet: 'Heute kein gemeinsames Abendessen',
        noDinnerUndo: 'Doch gemeinsames Abendessen',
        note: 'Notiz der Köchin oder des Kochs',
        noteHint: 'Alle im Haus sehen das, aber nicht auf der Tafel.',
        meal: 'Auf dem Speiseplan: {title}',
        groceries: 'Einkauf eintragen',
        listChanged: 'Essensliste geändert · Neu aufteilen',
        settings: 'Einstellungen Essensliste',
        cutoff: 'Anmelden bis',
        cutoffHint: 'Zwischen 10:00 und 21:00.',
        days: 'Tage mit gemeinsamem Abendessen',
        houseDefault: 'Wer noch nichts gewählt hat',
        houseDefaultUnknown: 'Fragen',
        houseDefaultIn: 'Isst mit',
        houseDefaultOut: 'Isst nicht mit',
        remind: 'Erinnerung vor der Frist',
        remindOff: 'Aus',
        remindMinutes: '{n} Min.',
        remindHours: '{n} Std.',
        cookItem: 'Kochdienst aus dem Plan',
        cookItemNone: 'Keiner (selbst übernehmen)',
        myDefault: 'Mein Standard',
        myDefaultHint: 'Pro Wochentag. Eine eigene Wahl für einen Tag geht immer vor.',
        prefIn: 'Mit',
        prefOut: 'Nicht',
        prefAsk: 'Frag mich',
        signedIn: '{name} isst mit',
        signedOut: '{name} isst nicht mit',
        cleared: 'Wahl entfernt',
        closedToast: 'Die Anmeldung ist geschlossen.',
        widgetAll: 'Zur Essensliste',
        widgetNotYet: 'Du hast noch nicht gewählt.',
        widgetYouIn: 'Du isst mit',
        widgetYouOut: 'Du isst nicht mit',
    },
    costs: {
        visibleAll: 'Alle im Haus sehen Ausgaben und Salden. Es fließt kein Geld über AMUMIN.',
        visibleTwoHome: 'Nur die Eltern sehen das. Kinder sehen nichts. Es fließt kein Geld über AMUMIN. Auf die Tafel kommt nur etwas, wenn du das selbst ausdrücklich für ein Tablet bestätigst; das kannst du jederzeit wieder wegnehmen.',
        tabExpenses: 'Ausgaben',
        tabBalance: 'Saldo',
        tabSettled: 'Verrechnet',
        add: 'Ausgabe',
        empty: 'Noch keine Ausgaben.',
        emptyBody: 'Trag eine Ausgabe ein; AMUMIN rechnet aus, wer was bekommt.',
        rowPaid: 'bezahlt von {name}',
        rowFor: 'für {n}',
        new: 'neu',
        edited: 'bearbeitet',
        questionBadge: 'Frage offen',
        locked: 'abgeschlossen',
        loadMore: 'Mehr laden',
        deletedList: 'Gelöscht ({n})',
        deletedHint: 'Noch 30 Tage wiederherstellbar.',
        newTitle: 'Neue Ausgabe',
        editTitle: 'Ausgabe ändern',
        amount: 'Betrag',
        amountHint: 'Zum Beispiel 12,50',
        amountInvalid: 'Gib einen Betrag ein, zum Beispiel 12,50.',
        amountTooLarge: 'Dieser Betrag ist zu hoch.',
        ambiguous: 'Meinst du {a} oder {b}?',
        confirmLarge: 'Stimmt {amount}?',
        confirmLargeYes: 'Ja, stimmt',
        description: 'Beschreibung',
        descriptionHint: 'Alle im Haus sehen das',
        paidBy: 'Bezahlt von',
        date: 'Datum',
        dateFuture: 'Ein Datum in der Zukunft geht nicht.',
        dateLocked: 'Dieser Zeitraum ist abgeschlossen (bis {date}).',
        split: 'Aufteilung',
        splitEqual: 'Gleich',
        splitWeights: 'Nach Anteil',
        splitExact: 'Genau',
        splitDinner: 'Esser vom {date}',
        splitDinnerHint: 'Aufgeteilt auf alle, die mitgegessen haben; Gäste zählen bei der Person, die sie mitbrachte.',
        remaining: 'noch {amount} aufzuteilen',
        tooMuch: '{amount} zu viel',
        perPerson: 'Pro Person',
        nobody: 'Wähle mindestens eine Person.',
        enteredBy: 'eingetragen von {name}',
        editedBy: 'bearbeitet von {name} am {date}',
        edit: 'Ändern',
        delete: 'Löschen',
        deleteConfirm: 'Bist du sicher?',
        deleteBody: 'Du kannst sie noch 30 Tage wiederherstellen.',
        deleted: 'Gelöscht',
        restore: 'Wiederherstellen',
        restored: 'Wiederhergestellt',
        question: 'Stimmt etwas nicht?',
        questionAsked: 'Deine Frage steht bei der Ausgabe.',
        questionOpen: '{name} fragt, ob das stimmt',
        questionResolve: 'Stimmt so',
        questionAdjust: 'Anpassen',
        questionWithdraw: 'Frage zurückziehen',
        detailTitle: 'Ausgabe',
        lockedNote: 'Diese Ausgabe liegt in einem abgeschlossenen Zeitraum.',
        gets: 'bekommt noch {amount}',
        owes: 'muss noch {amount} verrechnen',
        even: 'steht auf null',
        twoHomeOpen: 'noch zu verrechnen: {amount}',
        suggestions: 'Vorschlag zum Verrechnen',
        suggestionLine: '{from} → {to} {amount}',
        copy: 'Text kopieren',
        copied: 'Kopiert',
        iPaid: 'Ich habe bezahlt',
        wasPaid: 'Ist bezahlt',
        settleTitle: 'Verrechnung',
        settleHint: 'Es fließt kein Geld über AMUMIN; das ist nur eine Notiz.',
        settleSaved: 'Notiert. {name} bestätigt es noch.',
        settleSavedConfirmed: 'Notiert.',
        pending: 'Wartende Verrechnungen',
        pendingLine: '{from} meldet {amount} bezahlt',
        confirm: 'Stimmt',
        reject: 'Stimmt nicht',
        waiting: 'wartet auf {name}',
        confirmed: 'bestätigt',
        unconfirmed: 'nicht bestätigt',
        noLogins: '{names} haben noch keinen eigenen Login. Bis sie ihre Einladung annehmen, verwaltest du ihre Ausgaben und ein Ausgleich an sie zählt sofort (nicht bestätigt).',
        noLoginsOne: '{names} hat noch keinen eigenen Login. Bis die Einladung angenommen ist, verwaltest du die Ausgaben und ein Ausgleich zählt sofort (nicht bestätigt).',
        inviteHousemates: 'Mitbewohner einladen',
        removeSettlement: 'Entfernen',
        carried: 'Übernommener Saldo',
        closeTitle: 'Zeitraum abschließen',
        closeBody: 'Abschließen bis {date}.',
        closeHelp: 'Offene Salden werden übernommen. Ältere Einträge werden gesperrt und 24 Monate nach ihrem Datum gelöscht.',
        closeButton: 'Abschließen bis {date}',
        closeQuestions: 'Erst die offenen Fragen beantworten ({n}).',
        closePending: 'Erst die wartenden Verrechnungen ({n}).',
        closeNothing: 'Es gibt noch nichts abzuschließen.',
        closed: 'Abgeschlossen bis {date}',
        lastClosed: 'Zuletzt abgeschlossen bis {date}',
        allSettled: 'Alles verrechnet',
        exportCsv: 'CSV exportieren',
        settledEmpty: 'Noch keine Verrechnungen.',
        leaverWarn: '{name} hat noch {amount} offen.',
        leaverHint: 'Verrechnet das zuerst oder sprecht es gemeinsam ab. Der Saldo bleibt in der Übersicht.',
        offWarn: 'Kosten teilen wird ausgeschaltet. Die Daten werden 12 Monate aufbewahrt und danach gelöscht.',
        widgetGets: 'Du bekommst noch {amount}',
        widgetOwes: 'Du musst noch {amount} verrechnen',
        widgetEven: 'Alles verrechnet',
        widgetAll: 'Zu den Kosten',
        twoHomeConfirm: 'Funktioniert, wenn ihr beide Eltern in diesem Haushalt seid. Kinder sehen nichts.',
        twoHomeConfirmYes: 'Einschalten',
    },
    bookings: {
        intro: 'Waschmaschine, Trockner, Raum oder Gästebett: sieh, wer wann dran ist.',
        empty: 'Noch nichts zu reservieren.',
        emptyBody: 'Wähle, was ihr teilt. Die Standardregeln kannst du später ändern.',
        addKind: '+ {name}',
        day: 'Tag',
        prevDay: 'Vorheriger Tag',
        nextDay: 'Nächster Tag',
        today: 'Heute',
        free: 'frei',
        mine: 'du',
        closedHours: 'geschlossen',
        dstHour: 'Zeitumstellung',
        tapFree: 'Tippe auf eine freie Zeit, um zu reservieren.',
        sheetTitle: '{resource} reservieren',
        start: 'Beginnt um',
        duration: 'Wie lange',
        forWho: 'Für wen',
        book: 'Reservieren',
        booked: '{resource} {time} reserviert',
        fromDate: 'Von',
        toDate: 'Bis einschließlich',
        maxNights: 'Höchstens {n} Nächte am Stück.',
        overlap: 'Um {time} ist schon {name} dran. Nächste freie Zeit: {next}.',
        overlapNoNext: 'Diese Zeit ist schon reserviert.',
        takeNext: '{time} nehmen',
        err: {
            past: 'Diese Zeit ist schon vorbei.',
            max_days_ahead: 'Reservieren geht bis zu {n} Tage im Voraus.',
            slot: 'Wähle eine Zeit im {n}-Minuten-Raster.',
            dst_hour: 'Diese Zeit liegt in der Stunde der Zeitumstellung. Wähle eine andere Zeit.',
            max_minutes: 'Höchstens {duration} am Stück.',
            closed_hours: 'Die {resource} geht von {from} bis {until}.',
            quota: 'Du hast diese Woche schon {n} Reservierungen für die {resource}.',
            max_days: 'Höchstens {n} Tage am Stück.',
        },
        myTitle: 'Meine Reservierungen',
        myEmpty: 'Du hast nichts reserviert.',
        cancel: 'Stornieren',
        cancelled: 'Storniert',
        done: 'Fertig, freigeben',
        freed: 'Wieder frei',
        viaBoard: 'über die Tafel',
        cancelledBoard: 'über die Tafel storniert, {time}',
        manage: 'Verwalten',
        manageTitle: 'Dinge zum Reservieren',
        addThing: 'Ding hinzufügen',
        editThing: '{name} anpassen',
        name: 'Name',
        kind: 'Art',
        unit: 'Reservieren pro',
        unitSlot: 'Zeitfenster',
        unitDay: 'ganzer Tag',
        slotMinutes: 'Zeitfenster',
        defaultMinutes: 'Standarddauer',
        maxMinutes: 'Höchstens am Stück',
        maxDays: 'Höchstens Tage am Stück',
        maxAhead: 'Im Voraus reservieren (Tage)',
        perWeek: 'Pro Person pro Woche',
        perWeekNone: 'Keine Grenze',
        openFrom: 'Offen von',
        openUntil: 'Offen bis',
        alwaysOpen: 'Immer offen',
        onBoard: 'Auf der Tafel im Flur',
        archive: 'Archivieren',
        unarchive: 'Zurückholen',
        archived: 'Archiviert',
        minutes: '{n} Min.',
        hours: '{n} Std.',
        widgetNext: 'Du: {resource} {time}',
        widgetFreeNow: '{resource}: jetzt frei',
        widgetBusyUntil: '{resource}: belegt bis {time}',
        widgetAll: 'Zum Reservieren',
        kinds: {
            washer: 'Waschmaschine',
            dryer: 'Trockner',
            room: 'Raum',
            guest_bed: 'Gästebett',
            other: 'Anderes',
        },
    },
    setup: {
        residents: 'Wie viele seid ihr?',
        residentsLess: 'Weniger',
        residentsMore: 'Mehr',
        shares: 'Was teilt ihr?',
        shareNames: {
            kitchen: 'Küche',
            bathroom: 'Bad',
            laundry: 'Waschmaschine',
            dryer: 'Trockner',
            common_room: 'Gemeinschaftsraum',
            guest_bed: 'Gästebett',
            groceries: 'Einkäufe',
            costs: 'Kosten',
        },
        sameRights: 'Mitbewohnende bekommen dieselben Rechte wie du.',
        housemates: 'Mitbewohnende',
        housematesHint: 'Ihre Namen, dann stehen sie gleich im Plan und auf der Essensliste.',
        housemateName: 'Name Mitbewohner/in {n}',
        housematesAdd: 'Mitbewohnende hinzufügen',
        housematesAdded: 'Mitbewohnende hinzugefügt: {n}',
        housemateEmail: 'E-Mail von Mitbewohner {n} (freiwillig)',
        invitesSent: 'Einladungen verschickt: {n}',
        invitesLater: 'Noch nicht eingeladen. Das geht später unter Mitbewohner.',
        oneByOne: 'Oder eine einzelne Person (zum Beispiel ein Kind oder ein Babysitter)',
        planTitle: 'So richten wir das Haus ein',
        planBody: 'Das kommt dazu. Es wird nie etwas entfernt; was schon da ist, bleibt, wie es ist.',
        planRooms: 'Räume: {list}',
        planDuties: 'Plan: {list}',
        planResources: 'Reservieren: {list}',
        planDinner: 'Essensliste: anmelden bis {time}',
        run: 'Haus einrichten',
        again: 'Erneut einrichten',
        againHint: 'Fügt nur hinzu, was fehlt. Es wird nichts entfernt.',
        doneToast: 'Das Haus ist eingerichtet.',
        nothingNew: 'Alles war schon da.',
        offTitle: 'Ein Modul mit Daten wird ausgeschaltet',
        offDinner: 'Wer isst mit wird ausgeschaltet. Die Daten werden 12 Monate aufbewahrt und danach gelöscht.',
        offBookings: 'Reservieren wird ausgeschaltet. Die Daten werden 12 Monate aufbewahrt und danach gelöscht.',
        csv: 'Kosten als CSV herunterladen',
    },
    push: {
        dinner: 'Wer isst mit',
        dinnerHint: '„Isst du mit?“ vor der Frist, und wer kocht, erfährt, wer kommt.',
        bookings: 'Reservieren',
        bookingsHint: 'Deine Reservierung beginnt gleich, oder jemand hat auf der Tafel storniert.',
    },
    // Ronde 1 golf 8 (ON-3): huisgenoten per e-mail uitnodigen.
    invite: {
        title: '{name} einladen',
        body: '{name} bekommt eine E-Mail mit einem Link und wählt selbst ein Passwort. Mitbewohner bekommen dieselben Rechte wie du.',
        email: 'E-Mail-Adresse',
        send: 'Einladung senden',
        sent: 'Einladung gesendet an {email}',
        pending: 'Eingeladen: {email}',
        resend: 'Erneut senden',
        taken: 'Diese Person hat schon einen eigenen Login.',
        already: 'Diese Adresse gehört schon zu diesem Zuhause.',
        limit: 'Heute wurden schon 20 Einladungen verschickt. Bitte versuch es morgen noch einmal.',
        inUse: 'Diese Adresse hat schon eine Einladung zum Mitschauen. Zieh sie zuerst zurück.',
        loginNew: 'Melde dich mit deinem neuen Passwort an. Deine E-Mail-Adresse ist schon eingetragen.',
        hint: 'Noch ohne eigenen Login: {names}. Tippe auf einen Namen, um die Person per E-Mail einzuladen.',
        landingTitle: 'Einladung in dein Zuhause',
        landingBody: '{inviter} lädt dich zu {household} ein. Du bist dort als {member} eingetragen.',
        accepted: 'Willkommen bei {household}. Du kannst die App jetzt nutzen.',
    },
};
//# sourceMappingURL=samenApp.de.js.map